<script lang="ts" setup="">
import {computed, watch} from "vue"
import * as Sentry from "@sentry/browser"
import {parseBase64JsonUtf8} from "@/common/utils/string";

type SentryContext = Record<string, unknown>

const props = defineProps<{ context?: SentryContext, contextBase64?: string }>()

const context = computed(() => {
  if (props.context) {
    return props.context
  }

  if (!props.contextBase64) {
    throw new Error("SentryContext requires either the `context` or the `context-base64` prop.")
  }

  return parseBase64JsonUtf8(props.contextBase64) as SentryContext
})

function onContext() {
  // console.debug("Init Sentry Context", context.value)

  if (context.value.ip_address === 'auto') {
    // Because Inertia is a stupid hack that can't handle {{ appearing in a prop.
    // TODO: hack Inertia itself to transform '{{' to '&#123;&#123;'
    context.value.ip_address = '{{auto}}'
  }

  Sentry.setUser(context.value)
}

watch(context, onContext, {immediate: true})
</script>

<template>
  <div class="debug debug-border-green">
    <pre>SENTRY CONTEXT: {{ context }}</pre>
  </div>
</template>
